import { useGuardedNavigate } from "./NavigationGuard";
import css from "./studio.module.css";

/**
 * A picker with nothing to pick — FR-18, FR-19.
 *
 * Rendered **in place of** the control, not as a disabled first option, so the
 * way out is readable without opening a menu that has nothing in it.
 *
 * The link goes through the guard, which matters more here than anywhere: this
 * is the one place the app actively invites the author to leave a half-finished
 * asset. The round trip still costs the in-progress asset (accepted 2026-08-31,
 * spec risk table) — the guard is what makes that loss announced rather than
 * silent.
 */
export function EmptyPickerNote({
  message,
  linkLabel,
  to,
}: {
  message: string;
  linkLabel: string;
  to: string;
}) {
  const guardedNavigate = useGuardedNavigate();

  return (
    <p className={css.emptyPicker}>
      {message}{" "}
      <a
        href={to}
        className={css.crumbLink}
        onClick={(e) => {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
          e.preventDefault();
          guardedNavigate(to);
        }}
      >
        {linkLabel}
      </a>
    </p>
  );
}
